import { withHandlers } from 'recompose'

const withHandleCancel = withHandlers({
  handleCancel: props => e => {
    e.preventDefault()
    props.onCancel()
  }
})

export default withHandleCancel



// WEBPACK FOOTER //
// ./src/services/mycharity/withHandleCancel.js